import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { httpClient } from '@/shared/lib/httpClient'
import { apiV1 } from '@/shared/api/apiPrefix'

const countrySchema = z.object({
  code: z.string(),
  name: z.string(),
  // Informational display currency only - settlement is always EUR.
  display_currency: z.string().nullable(),
})

const countriesResponseSchema = z.object({
  data: z.array(countrySchema),
})

export type Country = z.infer<typeof countrySchema>

/** Active destination countries for the catalogue facet (RV-60-A). */
export function useCountries() {
  return useQuery({
    queryKey: ['countries'],
    queryFn: async (): Promise<Country[]> => {
      const res = await httpClient.get<unknown>(apiV1('/countries'))
      return countriesResponseSchema.parse(res.data).data
    },
    // Reference data - cache aggressively.
    staleTime: 60 * 60 * 1000,
  })
}
